import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class CacheStorageService {
  private cache: { [key: string]: any } = {};
  setDataInCache(key: string, value: any): void {
    this.cache[key] = value;
  }
  getDataFromCache(key: string): any {
    return this.cache[key];
  }
  removeDataFromCache(key: string): void {
    if (this.cache.hasOwnProperty(key)) {
      delete this.cache[key];
    }
  }
  clearCache(): void {
    this.cache = {};
  }
  set(key: string, value: any): void {
    this.setDataInCache(key, value);
  }
  get(key: string): any {
    return this.getDataFromCache(key);
  }
  remove(key: string): void {
    this.removeDataFromCache(key);
  }
  clear(): void {
    this.clearCache();
  }
  setDataInCacheWithExpiration(key: string, value: any, expirationInSeconds: number): void {
    this.cache[key] = {
      value,
      expirationTime: Date.now() + expirationInSeconds * 1000,
    };
  }
  getDataFromCacheWithExpiration(key: string): any {
    const cachedItem = this.cache[key];
    if (cachedItem && cachedItem.expirationTime && cachedItem.expirationTime > Date.now()) {
      return cachedItem.value;
    }
    return null;
  }
  removeExpiredItems(): void {
    for (const key in this.cache) {
      if (this.cache.hasOwnProperty(key) && this.cache[key].expirationTime < Date.now()) {
        delete this.cache[key];
      }
    }
  }
  getCacheSize(): number {
    return Object.keys(this.cache).length;
  }
  getAllKeys(): string[] {
    return Object.keys(this.cache);
  }
}
